export default () => ({
  inverter: null,
  reverter: null,
  inverterFinal: null,

  category: null,

  page: 1,

  hasMore: true,

  invert: true,

  init() {
    const options = {
      root: null,
      rootMargin: '10% 0px 0px 0px',
      threshold: 0.1,
    }

    this.$watch('invert', value => {
      if (value) {
        document.body.style.setProperty('--bg', '#FFFFFF')
        document.body.style.setProperty('--color', '#000000')
      } else {
        document.body.style.setProperty('--bg', '#000000')
        document.body.style.setProperty('--color', '#FFFFFF')
      }
    })

    const invertCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.invert = true
        } else {
          this.invert = false
        }
      })
    }

    this.inverter = new IntersectionObserver(invertCallback, {
      ...options
    })

    this.initPosts()
  },

  initPosts() {
    this.inverter.disconnect()

    this.$refs.posts.querySelectorAll(':scope > .post-item.is-invert').forEach(el => this.inverter.observe(el))
  },

  fetchPosts() {
    this.isLoading = true

    const url = new URL(window.location.href)
    url.searchParams.set('paged', this.page)

    if (this.category !== null) {
      url.searchParams.set('cat', this.category)
    }
  
    window.jQuery.ajax({
      url: url.toString(),
      success: response => {
        const items = window.jQuery(response).find('.insights--posts_wrap .post-item')

        this.$refs.posts.append(...items)
        this.hasMore = items.length < 8
        this.isLoading = false
        this.initPosts()
      }
    })
  }
})